// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  options: {
    wait: number;
    onPending?: (pending: boolean) => void;
  }
): {
  (...args: Parameters<T>): void;
  now: (...args: Parameters<T>) => void;
  cancel: () => void;
} {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  const debouncedFn = function (this: unknown, ...args: Parameters<T>) {
    options.onPending?.(true);

    const later = () => {
      timeout = null;
      options.onPending?.(false);
      func.apply(this, args);
    };

    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(later, options.wait);
  };

  debouncedFn.cancel = function () {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
      options.onPending?.(false);
    }
  };

  debouncedFn.now = function (this: unknown, ...args: Parameters<T>) {
    debouncedFn.cancel();
    func.apply(this, args);
  };

  return debouncedFn;
}
